module.exports = {
	"ha": "viha",
	"id": 5.5,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by Age Category and MSM Status, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "55%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "55%",
				"height": "45%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -80,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.45454545454545,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#043f61"
					},
					{
						"y": 95.45454545454545,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0c4250"
					},
					{
						"y": 95.45454545454545,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0d4440"
					},
					{
						"y": 86.36363636363636,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#09472e"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.05882352941177,
						"dataLabels": {
							"enabled": false,
							"format": "66"
						},
						"color": "#043f61"
					},
					{
						"y": 83.82352941176471,
						"dataLabels": {
							"enabled": false,
							"format": "57"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.94117647058823,
						"dataLabels": {
							"enabled": false,
							"format": "53"
						},
						"color": "#0d4440"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "51"
						},
						"color": "#09472e"
					},
					{
						"y": 42.64705882352941,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.50746268656717,
						"dataLabels": {
							"enabled": false,
							"format": "66"
						},
						"color": "#043f61"
					},
					{
						"y": 92.53731343283582,
						"dataLabels": {
							"enabled": false,
							"format": "62"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.56716417910447,
						"dataLabels": {
							"enabled": false,
							"format": "58"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.61194029850746,
						"dataLabels": {
							"enabled": false,
							"format": "52"
						},
						"color": "#09472e"
					},
					{
						"y": 56.71641791044776,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.63013698630137,
						"dataLabels": {
							"enabled": false,
							"format": "288"
						},
						"color": "#043f61"
					},
					{
						"y": 98.63013698630137,
						"dataLabels": {
							"enabled": false,
							"format": "288"
						},
						"color": "#0c4250"
					},
					{
						"y": 97.6027397260274,
						"dataLabels": {
							"enabled": false,
							"format": "285"
						},
						"color": "#0d4440"
					},
					{
						"y": 94.17808219178082,
						"dataLabels": {
							"enabled": false,
							"format": "275"
						},
						"color": "#09472e"
					},
					{
						"y": 74.31506849315068,
						"dataLabels": {
							"enabled": false,
							"format": "217"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0c4250"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0d4440"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#09472e"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#0c4250"
					},
					{
						"y": 96.15384615384616,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.92307692307693,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#09472e"
					},
					{
						"y": 53.84615384615385,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "65"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "65"
						},
						"color": "#0c4250"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "65"
						},
						"color": "#0d4440"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "65"
						},
						"color": "#09472e"
					},
					{
						"y": 56.92307692307692,
						"dataLabels": {
							"enabled": false,
							"format": "37"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.06542056074767,
						"dataLabels": {
							"enabled": false,
							"format": "212"
						},
						"color": "#043f61"
					},
					{
						"y": 99.06542056074767,
						"dataLabels": {
							"enabled": false,
							"format": "212"
						},
						"color": "#0c4250"
					},
					{
						"y": 96.26168224299066,
						"dataLabels": {
							"enabled": false,
							"format": "206"
						},
						"color": "#0d4440"
					},
					{
						"y": 91.58878504672897,
						"dataLabels": {
							"enabled": false,
							"format": "196"
						},
						"color": "#09472e"
					},
					{
						"y": 62.616822429906534,
						"dataLabels": {
							"enabled": false,
							"format": "134"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 68.75,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#043f61"
					},
					{
						"y": 37.5,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0c4250"
					},
					{
						"y": 37.5,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0d4440"
					},
					{
						"y": 31.25,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#09472e"
					},
					{
						"y": 25,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 92,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#043f61"
					},
					{
						"y": 88,
						"dataLabels": {
							"enabled": false,
							"format": "22"
						},
						"color": "#0c4250"
					},
					{
						"y": 88,
						"dataLabels": {
							"enabled": false,
							"format": "22"
						},
						"color": "#0d4440"
					},
					{
						"y": 88,
						"dataLabels": {
							"enabled": false,
							"format": "22"
						},
						"color": "#09472e"
					},
					{
						"y": 56.00000000000001,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.14814814814815,
						"dataLabels": {
							"enabled": false,
							"format": "53"
						},
						"color": "#043f61"
					},
					{
						"y": 87.03703703703704,
						"dataLabels": {
							"enabled": false,
							"format": "47"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.18518518518519,
						"dataLabels": {
							"enabled": false,
							"format": "46"
						},
						"color": "#0d4440"
					},
					{
						"y": 74.07407407407408,
						"dataLabels": {
							"enabled": false,
							"format": "40"
						},
						"color": "#09472e"
					},
					{
						"y": 57.407407407407405,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.6923076923077,
						"dataLabels": {
							"enabled": false,
							"format": "254"
						},
						"color": "#043f61"
					},
					{
						"y": 92.3076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "240"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.38461538461539,
						"dataLabels": {
							"enabled": false,
							"format": "235"
						},
						"color": "#0d4440"
					},
					{
						"y": 84.61538461538461,
						"dataLabels": {
							"enabled": false,
							"format": "220"
						},
						"color": "#09472e"
					},
					{
						"y": 65.38461538461539,
						"dataLabels": {
							"enabled": false,
							"format": "170"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.545454545454541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.523809523809524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -42.10526315789473,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.941176470588236,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.636363636363635,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.017543859649122,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.7735849056603765,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -43.13725490196079,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.4925373134328401,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.060606060606055,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.451612903225811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.344827586206895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.923076923076927,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.3698630136986356,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.041666666666663,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.508771929824561,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.8461538461538436,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -43.07692307692308,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.9345794392523366,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.8301886792452824,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.854368932038833,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.63265306122449,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -31.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -45.45454545454546,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -7.9999999999999964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.347826086956519,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -36.36363636363637,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.851851851851849,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.32075471698113,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.127659574468088,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.043478260869568,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.499999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.3076923076923106,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.511811023622048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.083333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.382978723404253,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.72727272727273,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=22"
			},
			{
				"x": 9,
				"text": "30-39<br>n=68"
			},
			{
				"x": 15,
				"text": "40-49<br>n=67"
			},
			{
				"x": 21,
				"text": ">=50<br>n=292"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=3"
			},
			{
				"x": 34,
				"text": "30-39<br>n=26"
			},
			{
				"x": 40,
				"text": "40-49<br>n=65"
			},
			{
				"x": 46,
				"text": ">=50<br>n=214"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=16"
			},
			{
				"x": 59,
				"text": "30-39<br>n=25"
			},
			{
				"x": 65,
				"text": "40-49<br>n=54"
			},
			{
				"x": 71,
				"text": ">=50<br>n=260"
			}
		],
		"dataTable": {
			"MSM:<30": [
				22,
				21,
				21,
				21,
				19,
				11
			],
			"MSM:30-39": [
				68,
				66,
				57,
				53,
				51,
				29
			],
			"MSM:40-49": [
				67,
				66,
				62,
				58,
				52,
				38
			],
			"MSM:>=50": [
				292,
				288,
				288,
				285,
				275,
				217
			],
			"Non-MSM:<30": [
				3,
				3,
				3,
				3,
				3,
				3
			],
			"Non-MSM:30-39": [
				26,
				26,
				26,
				25,
				20,
				14
			],
			"Non-MSM:40-49": [
				65,
				65,
				65,
				65,
				65,
				37
			],
			"Non-MSM:>=50": [
				214,
				212,
				212,
				206,
				196,
				134
			],
			"Unknown:<30": [
				16,
				11,
				6,
				6,
				5,
				4
			],
			"Unknown:30-39": [
				25,
				23,
				22,
				22,
				22,
				14
			],
			"Unknown:40-49": [
				54,
				53,
				47,
				46,
				40,
				31
			],
			"Unknown:>=50": [
				260,
				254,
				240,
				235,
				220,
				170
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_5.json
// module id = 340
// module chunks = 0